<template>
  <div class="sms-template">
    <div class="sms-template__header">
      <div class="sms-template__desc">
        审核时长：一般 2 小时内完成；若内容包含 URL、链接、联系方式等引流信息，至少需 7
        个工作日；如遇升级核验、审核任务较多或非工作时间，审核时间可能延长，敬请耐心等待。
        <br />
        审核工作时间：周一至周日 9:00–21:00（法定节假日顺延）
      </div>

      <vab-query-form class="sms-template__actions">
        <vab-query-form-left-panel :span="3">
          <el-button icon="plus" type="primary" @click="openTemplateCreator">添加模板</el-button>
        </vab-query-form-left-panel>
        <vab-query-form-right-panel :span="21">
          <el-form inline @submit.prevent="query(1)">
            <el-form-item label="关键词查询">
              <el-input
                v-model="queryParams.subject"
                clearable
                placeholder="请输入关键词查询"
                @change="query(1)"
                @keyup.enter.native="query(1)"
              />
            </el-form-item>
            <el-form-item label="审核状态">
              <el-select v-model="queryParams.auditStatus" clearable placeholder="请选择审核状态" @change="query(1)">
                <el-option label="全部" :value="void 0" />
                <el-option label="待审核" value="PENDING" />
                <el-option label="通过" value="APPROVED" />
                <el-option label="驳回" value="REJECTED" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="search" type="primary" @click="query(1)">查询</el-button>
              <el-button icon="refresh" type="warning" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </vab-query-form-right-panel>
      </vab-query-form>
    </div>

    <el-table v-loading="loading" border :data="tableData" size="small" style="width: 100%">
      <el-table-column label="模板主题" prop="subject" show-overflow-tooltip />
      <el-table-column label="短信签名" prop="signName" show-overflow-tooltip />
      <el-table-column label="模板内容" prop="content" show-overflow-tooltip />
      <el-table-column label="审核状态" prop="auditStatus" width="120">
        <template #default="{ row }">{{ auditStatusLabel(row.auditStatus) }}</template>
      </el-table-column>
      <el-table-column label="驳回原因" prop="rejectReason" show-overflow-tooltip />
      <el-table-column label="创建时间" prop="createTime" width="180" />
    </el-table>

    <div class="sms-template__pager">
      <el-pagination
        v-model:current-page="queryParams.pageNum"
        background
        layout="prev, pager, next"
        :page-size="queryParams.pageSize"
        :total="queryParams.total"
        @current-change="query"
      />
    </div>

    <TemplateCreator
      app-key="WX_MINI_WEMEET"
      :visible="templateCreatorVisible"
      @close="templateCreatorVisible = false"
      @success="handleTemplateCreateSuccess"
    />
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
  import { querySmsTemplateList } from '@/api/sms'
  import TemplateCreator from './TemplateCreator.vue'

  const { proxy } = getCurrentInstance()

  const defaultQueryParams = {
    subject: '',
    auditStatus: undefined,
    pageNum: 1,
    pageSize: 10,
    total: 0,
  }

  const queryParams = reactive({ ...defaultQueryParams })
  const tableData = ref([])
  const loading = ref(false)
  const templateCreatorVisible = ref(false)

  const AUDIT_STATUS_LABEL = {
    PENDING: '待审核',
    APPROVED: '审核通过',
    REJECTED: '审核驳回',
  }

  function auditStatusLabel(status) {
    return AUDIT_STATUS_LABEL[status] || status || '--'
  }

  function query(pageNum = queryParams.pageNum) {
    queryParams.pageNum = pageNum
    const payload = {
      subject: queryParams.subject,
      auditStatus: queryParams.auditStatus,
      pageNum: queryParams.pageNum,
      pageSize: queryParams.pageSize,
    }

    loading.value = true
    querySmsTemplateList(payload)
      .then((res) => {
        if (res.code !== 200) return
        const { list = [], total = 0 } = res.data || {}
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function reset() {
    Object.assign(queryParams, defaultQueryParams)
    query(1)
  }

  function openTemplateCreator() {
    templateCreatorVisible.value = true
  }

  function handleTemplateCreateSuccess() {
    templateCreatorVisible.value = false
    query(1)
  }

  onMounted(() => {
    query(1)
  })
</script>

<style lang="scss" scoped>
  .sms-template {
    padding: 16px;
  }

  .sms-template__header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .sms-template__desc {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 24px;
    border: 1px solid #b8d2e3;
    border-radius: 12px;
    background: #e7f0f6;
    color: #1f2937;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.8;
  }

  .sms-template__actions {
    margin-bottom: 4px;
  }

  .sms-template__pager {
    margin-top: 16px;
  }
</style>
